import React from 'react';
import { useLayoutEffect, useState } from 'react';
import styled from '@emotion/styled'
import { Box as GBox } from 'grommet';
import Divider from '@mui/material/Divider';
import 'typeface-roboto';


const Education = () => {
  let [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useLayoutEffect(() => {
    function updateSize() {
      console.log(window.innerWidth)
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <GBox animation="zoomIn" direction="column" style={{ margin: 10, background: "#fff", alignItems: "center", justifyContent: 'center',width:'100%' }}>
      <GBox direction="row-responsive" style={{ alignItems: "center",display:'flex', justifyContent:'center',width:(windowWidth <= 768 ? '76%' : '100%') }}>
        <GBox direction="column" style={{ margin: 5, padding: 0, justifyContent: "center", alignSelf: 'center', textAlign: (windowWidth <= 768 ? 'left': 'right'), width:'100%' }}>
          <h5 style={{ margin: 0, padding: 1, color: 'rgb(8, 98, 194)',fontSize:24 }}>Computer Programming <br /> & Analysis</h5>
        </GBox>
        <Divider orientation={windowWidth <=768 ? 'horizontal' : 'vertical'} style={{ color: "#ffffff", borderWidth: 2, borderColor: "#000000",width: (windowWidth <= 768 ? '100%' : 'auto') }} />
        <GBox direction="column" style={{ margin: 5, padding: 0, justifyContent: "center", alignSelf: 'left', textAlign: (windowWidth <= 768 ? 'left' : 'left'),width: (windowWidth <= 768 ? '100%' : '100%') }}>
          <h3 style={{ margin: 0, marginTop: 0, marginBottom: 0, color: 'rgb(193, 36, 36)',fontSize:28 }}>Seneca College</h3>

          <h5 style={{ margin: 0, fontWeight: 600, color: '#515151',fontSize:18 }}> Jan 2017 - April 2020</h5>
          <h6 style={{ margin: 0, fontWeight: 600, fontSize:15,marginBottom:2,color: 'rgb(193, 36, 36)', }} >Graduated With Honors</h6>
        </GBox>
      </GBox>
    </GBox>

  )

}

export default Education;